package gr.tech.GRAttestation.models.skus

import kotlinx.serialization.Serializable

@Serializable
data class SkuPreviewDTO(
    val id: Int,
    val sku: String,
    val description: String,
    val unitPrice: Long,
    val amountPerReceipt: Int,
)

